import { companiesId } from 'Utils/constants'

export const validatorCompany = CompanyId =>
  CompanyId === companiesId.cochez
    ? 'CO'
    : CompanyId === companiesId.novey
    ? 'NO'
    : null
